import { render } from "./ForgotPassForm.vue?vue&type=template&id=3b762956&scoped=true"
import script from "./ForgotPassForm.vue?vue&type=script&lang=js"
export * from "./ForgotPassForm.vue?vue&type=script&lang=js"

import "./ForgotPassForm.vue?vue&type=style&index=0&id=3b762956&scoped=true&lang=css"

import exportComponent from "/Users/ofmartinez/WebDev/orbeas/Holton-OrbeasRogue-Web-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b762956"]])

export default __exports__